module.exports = __webpack_public_path__ + "static/media/search-placeholder.a4044649.svg";